var React = require('react');

function ContentEyeball (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-eyeball"),React.createElement("path",{"d":"M24.75,28.63c-13,0-23.25-12.79-23.69-13.34a.87.87,0,0,1,0-1.08C1.5,13.66,11.77.88,24.75.88S48,13.66,48.44,14.21a.87.87,0,0,1,0,1.08C48,15.84,37.73,28.63,24.75,28.63ZM2.89,14.75C5,17.17,14.09,26.88,24.75,26.88S44.5,17.17,46.61,14.75C44.5,12.33,35.41,2.63,24.75,2.63S5,12.33,2.89,14.75Zm21.86,8.88a8.88,8.88,0,1,1,8.88-8.88A8.89,8.89,0,0,1,24.75,23.63Zm0-16a7.13,7.13,0,1,0,7.13,7.12A7.12,7.12,0,0,0,24.75,7.63Zm0,12a4.87,4.87,0,0,1-4.87-4.87.88.88,0,1,1,1.75,0,3.13,3.13,0,1,0,3.12-3.13.88.88,0,0,1,0-1.75,4.88,4.88,0,1,1,0,9.75Z","transform":"translate(-0.88 -0.88)","key":1})]);
}

ContentEyeball.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 47.75 27.75"};

module.exports = ContentEyeball;

ContentEyeball.default = ContentEyeball;
